module.exports = __webpack_public_path__ + "static/dr-corner-c3b7dc634d3d05e94290118231c5e116.svg";